// extracted by mini-css-extract-plugin
export default {"roomCardContainer":"RoomInfoCard_roomCardContainer__OclIT","roomMembers":"RoomInfoCard_roomMembers__3Ddei"};